import React, { useEffect, useState } from 'react';

import { Progress } from 'antd';

import { Box, Card, Stack, useMediaQuery, useTheme } from '@mui/material';

import PersonalInfoForm from './components/PersonalInfoForm';
import ProfileImage from './components/ProfileImage';
import SocialIconsContainer from './components/SocialIconsContainer';
import SocialNetworkFields from './components/SocialNetworkFields';
import Spin from 'components/Spin';
import TermComponent from 'components/Term';
import Text from 'components/Text';
import TitleFormComponent from 'components/TitleForm';
import { useThemeContext } from 'global/ThemeContext/ThemeContext';
import { useUser } from 'global/UserContext';
import { useUserFormCompletion } from 'hooks/useUserFormCompletion';
import { useUserSocialNetworks } from 'hooks/useUserSocialNetworks';
import { DataProtectionTerm } from 'utils/dataProtectionTerm';
import { getFormGroupIdByName } from 'utils/formMapper';

const BasicPersonalData: React.FC = () => {
  const theme = useThemeContext();
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(muiTheme.breakpoints.down('md'));
  const { user } = useUser();
  const {
    socialNetworks,
    loading: socialLoading,
    error: socialError,
    useSocialNetworksUpdate,
    refreshSocialNetworks,
  } = useUserSocialNetworks();
  const [groupId, setGroupId] = useState<string | undefined>(undefined);

  // Escuta atualizações nas redes sociais
  useSocialNetworksUpdate(() => {
    refreshSocialNetworks();
  });

  useEffect(() => {
    getFormGroupIdByName('Perfil do Usuário').then(id => {
      if (id) setGroupId(id);
    });
  }, []);

  const {
    progress,
    loading: loadingCompletionForm,
    error: errorCompletionForm,
  } = useUserFormCompletion(user?.id, groupId);
  const { networkTypes, loading: networksLoading } = useUserSocialNetworks();

  const { title, subtitle, description, content, version } = DataProtectionTerm;

  if (networksLoading || loadingCompletionForm) return <Spin centerHorizontally centerVertically />;

  if (errorCompletionForm)
    return (
      <Text color="red" bold textAlign="center">
        Erro ao carregar formulário
      </Text>
    );

  console.log('[BasicPersonalData] socialNetworks', socialNetworks, progress);

  return (
    <Stack direction="column" spacing={2}>
      <TermComponent
        title={title}
        subtitle={subtitle}
        description={description}
        content={content}
        version={version}
      />
      {/*       <ActionButtons />
       */}{' '}
      <Box>
        <TitleFormComponent title="Dados Pessoais" />
        <Stack
          direction={isMobile ? 'column' : 'row'}
          spacing={2}
          alignItems={isMobile ? 'center' : 'stretch'}
          height="fit-content"
        >
          <Box sx={{ width: isMobile ? '100%' : '50%' }}>
            <ProfileImage onClose={() => {}} />
          </Box>
          <Stack
            direction="column"
            spacing={1}
            sx={{
              height: 'fit-content',
              width: isMobile ? '100%' : '50%',
            }}
          >
            <Card
              sx={{
                borderRadius: 2,
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: '50%',
                minHeight: '120px',
                p: isMobile ? 1 : 2,
              }}
            >
              <Text color="textPrimary" bold>
                Preenchimento
              </Text>
              <Stack
                direction="column"
                spacing={1}
                alignItems="center"
                justifyContent="center"
                flex={1}
                marginTop={-2}
              >
                <Box width="100%">
                  <Text bold color="textPrimary" textAlign="right">
                    {progress?.toFixed(0)}%
                  </Text>
                  <Progress
                    percent={progress || 0}
                    showInfo={false}
                    strokeColor={theme.primary}
                    trailColor={theme.text.secondary}
                    size={{ height: 10 }}
                  />
                </Box>
              </Stack>
            </Card>
            <Card
              sx={{
                borderRadius: 2,
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: '50%',
                minHeight: '120px',
                p: isMobile ? 1 : 2,
              }}
            >
              <Text color="textPrimary" bold>
                Contatos
              </Text>
              <Stack
                direction="column"
                spacing={1}
                alignItems="center"
                justifyContent="center"
                flex={1}
              >
                <Box>
                  {socialNetworks.length > 0 ? (
                    <SocialIconsContainer
                      socialNetworks={socialNetworks}
                      socialLoading={socialLoading}
                      socialError={socialError}
                    />
                  ) : (
                    <Text color="textSecondary">Nenhuma rede social cadastrada</Text>
                  )}
                </Box>
              </Stack>
            </Card>
          </Stack>
        </Stack>
        <Box marginY={2}>
          <PersonalInfoForm />
        </Box>
        <Box>
          <SocialNetworkFields networkTypes={networkTypes} />
        </Box>
      </Box>
    </Stack>
  );
};

export default BasicPersonalData;
